var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'input')?_c('input',{staticClass:"input",class:{ 'input--error': _vm.error },attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function (ref) {
	var target = ref.target;

	return _vm.$emit('input', target.value);
},"blur":function($event){return _vm.$emit('blur')}}}):(_vm.type === 'textarea')?_c('textarea',{staticClass:"textarea",class:{ 'input--error': _vm.error },attrs:{"placeholder":_vm.placeholder,"spellcheck":"false"},domProps:{"value":_vm.value},on:{"input":function (ref) {
	var target = ref.target;

	return _vm.$emit('input', target.value);
},"blur":function($event){return _vm.$emit('blur')}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }